@use "ui/styles/colorsOld";

.wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 48px; // Changing this will change all banners in app!
  flex-shrink: 0;

  > div {
    display: flex;
    align-items: center;
  }
}